// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function toBoolean(value: any): boolean {
  if (value) {
    switch (value.toString().toLowerCase().trim()) {
      case 'true':
      case 'yes':
      case '1':
        return true;
      case 'false':
      case 'no':
      case '0':
      case null:
        return false;

      default: return Boolean(value);
    }
  }

  return false;
}

export function temp2(): number {
  return 0;
}
